module.exports = __webpack_public_path__ + "img/flag.43e5b125.svg";